// `Array.prototype.unique` - used by the BOM template picker (components/BomTemplates.vue) to stamp
// out duplicate materials. It used to sit at the top of that component file, which is fine as long
// as the file stays a module; now that the component is a `.vue` (where top-level code runs per
// instance) the patch lives here, module level, and the component imports it for the side effect.
Array.prototype.unique = function () {
  var a = this.concat()
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) a.splice(j--, 1)
    }
  }

  return a
}
